var Clear;
(function (Clear) {
    var Controller = (function () {
        function Controller() {

        }

        var obliviate = function (self) {
            $(self).remove();
        };

        var empty = function (self) {
            $(self).empty();
        };

        var clear = function (self) {
            self.value = '';
        };

        var uncheck = function (self) {
            self.checked = false;
        };

        var defaultify = function (self) {
            var _defaultValue = $(self).data('default');
            if (_defaultValue != 'undefined' && _defaultValue !== undefined) {
                $(self).val(_defaultValue + "");
            }
        };

        var reset = function (selector) {
            var element = $(selector);
            var inputs = element.find('input');
            var destroyable = element.find('.destroyable');
            var textareas = element.find('textarea');
            var selects = element.find('select');

            inputs.each(function () {
                switch (this.type) {
                    case 'text':
                        clear(this);
                        defaultify(this);
                        break;
                    case 'checkbox':
                        uncheck(this);
                        break;
                    case 'number':
                        defaultify(this);
                        break;
                    case 'time':
                        defaultify(this);
                        break;
                }
            });

            textareas.each(function () {
                empty(this);
                clear(this);
            });

            destroyable.each(function () {
                obliviate(this);
            });

            selects.each(function () {
                defaultify(this);
            });
        };

        Controller.prototype.clearForm = Controller.clearForm = Controller.form = function (_form) {
            reset('form[name="' + _form + '"]');
        };

        Controller.prototype.input = Controller.input = function (selector) {
            reset(selector);
        };

        return Controller;
    })();
    Clear.Controller = Controller;
})(Clear || (Clear = {}));
var Clear = new Clear.Controller();